import axios from './BaseService';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export async function createInviteCode(expiresInDays = null, isWildcard = false) {
    const response = await axios.post(`${API_URL}/invite-codes`, { expiresInDays, isWildcard });
    return response.data;
}

export async function getAllInviteCodes(page = 1, pageSize = 10) {
    const response = await axios.get(`${API_URL}/invite-codes?page=${page}&pageSize=${pageSize}`);
    return response.data;
}

export async function deleteInviteCode(id) {
    const response = await axios.delete(`${API_URL}/invite-codes/${id}`);
    return response.data;
}




